module.exports = __webpack_public_path__ + "static/media/iftekhar.28f1e65d.jpeg";